import { render, staticRenderFns } from "./VendorLoginVerificationForm.vue?vue&type=template&id=39fd4566&"
import script from "./VendorLoginVerificationForm.vue?vue&type=script&lang=js&"
export * from "./VendorLoginVerificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports